module.exports = __webpack_public_path__ + "img/Escudos_Civilizaciones_Aoe2.adacb062.png";